<template>
    <div class="main-content">
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"> <router-link class="nav-link active" to="/">Início</router-link></li>
                    <li class="breadcrumb-item active text-dark small">Categorias</li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Categorias</h4>
                    <span class="text-muted fs-7">Exibindo {{ categories.length }} de {{ totalItems }}</span>
                </div>

               <div class="d-flex gap-2 align-items-center">
                    <transition name="fade">
                        <div v-if="selectedIds.length > 0" class="d-flex align-items-center me-2 pe-3 border-end">
                            <button class="btn btn-pmg-danger btn-sm px-3"
                                @click="confirmDelete(selectedIds.length, true)">
                                <i class="bi bi-trash3 me-1"></i> Excluir ({{
                                    selectedIds.length ? selectedIds.length : 'categoria' }})
                            </button>
                        </div>
                    </transition>

                   

                    <!-- Dropdown Relatórios / Ferramentas Padronizado -->
                    <div class="dropdown me-2 pe-3 border-end">
                        <button class="btn btn-pmg-light dropdown-toggle" type="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="bi bi-printer me-1"></i> Relatórios / Ferramentas
                        </button>
                        <ul class="dropdown-menu shadow border-0 py-2">
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Exportar Dados</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('pdf')">
                                    <i class="bi bi-file-earmark-pdf text-danger me-2"></i> Relatório Geral (PDF)
                                </a>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openReportModal('xlsx')">
                                    <i class="bi bi-file-earmark-excel text-success me-2"></i> Planilha Completa (Excel)
                                </a>
                            </li>
                            <li>
                                <hr class="dropdown-divider opacity-10">
                            </li>
                            <li>
                                <h6 class="dropdown-header text-uppercase small fw-bold opacity-75">Ferramentas</h6>
                            </li>
                            <li>
                                <a class="dropdown-item py-2" href="#" @click.prevent="openImportModal">
                                    <i class="bi bi-cloud-arrow-up text-primary me-2"></i> Importar Categorias
                                </a>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-pmg-light" @click="refreshData" :disabled="loading" title="Atualizar tela">
                        <i class="bi bi-arrow-clockwise" :class="{ 'spin-animation': loading }"></i>
                    </button>
                    <button class="btn btn-pmg-light" @click="showFilter = !showFilter"
                        :class="{ 'active': showFilter }">
                        <i class="bi bi-funnel"></i> Filtrar
                    </button>

                    <button class="btn btn-pmg-primary" data-bs-toggle="modal" data-bs-target="#modalCategory"
                        @click="resetForm">
                        <i class="bi bi-plus-lg me-1"></i> Nova Categoria
                    </button>
                </div>
            </div>

            <div class="collapse" :class="{ 'show': showFilter }">
                <div class="card card-body mb-4 border-0 bg-light rounded-3">
                    <div class="row g-3">
                        <div class="col-md-10">
                            <input v-model="filter.name" type="text" class="form-control form-control-pmg"
                                placeholder="Filtrar por nome...">
                        </div>
                        <div class="col-md-2 d-flex">
                            <button class="btn btn-dark w-100 btn-pmg-dark fw-bold" @click="applyFilter">
                                <i class="bi bi-search me-1"></i> Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive">
                <table class="table table-pmg align-middle">
                    <thead>
                        <tr>
                            <th style="width: 5%">
                                <input type="checkbox" class="form-check-input" @change="toggleAll"
                                    :checked="isAllSelected">
                            </th>
                            <th style="width: 25%">Cód / Nome</th>
                            <th style="width: 55%">Descrição</th>
                            <th style="width: 55%">DRE</th>
                            <th style="width: 15%" class="text-end">Ações</th>
                        </tr>
                    </thead>

                    <tbody v-if="categories.length > 0">
                        <tr v-for="item in categories" :key="item.id"
                            :class="{ 'selected-row': selectedIds.includes(item.id) }">
                            <td><input type="checkbox" class="form-check-input" :value="item.id" v-model="selectedIds">
                            </td>
                            <td class="fw-bold text-dark">{{ item.name }}</td>
                            <td>
                                <div class="pmg-desc-cell text-truncate-custom">{{ item.description }}</div>
                            </td>
                            <td>
                                <div class="pmg-desc-cell text-truncate-custom">{{ translateDre(item) }}</div>
                            </td>
                            <td class="text-end">
                                <div class="dropdown">
                                    <button class="btn btn-pmg-icon border" data-bs-toggle="dropdown"
                                        data-bs-boundary="viewport">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-end shadow border-0">
                                        <li><a class="dropdown-item" href="#"
                                                @click.prevent="openModal('edit', item)"><i
                                                    class="bi bi-pencil me-2"></i>Editar</a></li>
                                        <li>
                                            <hr class="dropdown-divider">
                                        </li>
                                        <li><a class="dropdown-item text-danger" href="#"
                                                @click.prevent="confirmDelete(item)"><i
                                                    class="bi bi-trash me-2"></i>Excluir</a></li>

                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>

                    <tbody v-else>
                        <tr>
                            <td colspan="4" class="text-center py-5 text-muted">
                                <div class="d-flex flex-column align-items-center justify-content-center">
                                    <i class="bi bi-inbox fs-1 mb-2 text-secondary opacity-50"></i>
                                    <span class="fw-medium">Não há registros no momento.</span>
                                    <span class="small mt-1" v-if="filter.name">Tente limpar os filtros de busca.</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="text-center mt-4" v-if="hasMore">
                <button
                    class="btn btn-pmg-light px-5 btn-sm fw-bold d-inline-flex align-items-center justify-content-center"
                    @click="loadMore" :disabled="loading" style="min-width: 220px;">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                        aria-hidden="true"></span>

                    <span>{{ loading ? 'Carregando dados...' : 'Carregar mais itens' }}</span>
                </button>
            </div>
        </div>

        <div class="modal fade" id="modalCategory" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Categoria' : 'Nova Categoria' }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" id="closeModalBtn"></button>
                    </div>
                    <div class="modal-body px-4">
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">Nome</label>
                            <input v-model="form.name" type="text" class="form-control form-control-pmg"
                                placeholder="Informe um nome para a categoria">
                        </div>
                        <div class="mb-3">
                            <label class="form-label small fw-bold text-muted">Descrição</label>
                            <textarea v-model="form.description" class="form-control form-control-pmg" rows="3"
                                placeholder="Informe uma descrição para a categoria"></textarea>
                        </div>
                        <div class="mb-3">
                            <label class="form-label fw-bold text-secondary small mb-1">DRE (Demonstração do Resultado do Exercício)</label>
                            <select v-model="form.dre_group" class="form-select form-control-pmg">
                                <option value="" disabled>Selecione uma opção</option>
                                <option value="gross_revenue">Receita Bruta</option>
                                <option value="deductions">Dedução / Imposto</option>
                                <option value="variable_costs">Custo Variável</option>
                                <option value="fixed_costs">Custo Fixo</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer border-0 pb-4 px-4">
                        <button class="btn btn-pmg-light me-2" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="!isFormValid" @click="saveCategory">
                            {{ isEditing ? 'Atualizar' : 'Salvar Categoria' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4 text-center p-3">
                    <div class="modal-body">
                        <div class="text-danger mb-3">
                            <i class="bi bi-exclamação-triangle-fill fs-1"></i>
                        </div>
                        <h5 class="fw-bold">Tem certeza?</h5>
                        <p class="text-muted small">{{ isBulkDelete ? `Excluir ${selectedIds.length} categorias
                            selecionadas?` : `Excluir "${itemToDelete?.nome || itemToDelete?.name}"?` }}</p>
                    </div>
                    <div class="d-flex gap-2 justify-content-center pb-2">
                        <button class="btn btn-pmg-light px-4" data-bs-dismiss="modal">Cancelar</button>
                        <button class="btn btn-danger px-4 rounded-3" @click="executeDeletion">Confirmar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- MODAL DE IMPORTAÇÃO -->
        <div class="modal fade" id="modalImportPreview" tabindex="-1" aria-hidden="true" ref="modalImportPreview">
            <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4">
                        <h5 class="fw-bold m-0"><i class="bi bi-file-earmark-arrow-up me-2 text-primary"></i>Pré-visualização da Importação</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" @click="resetImport"></button>
                    </div>

                    <div class="modal-body p-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <span class="text-muted small">Siga o padrão das colunas para evitar erros: <strong>Nome, Descrição, Grupo_DRE</strong></span>
                            <a href="#" @click.prevent="downloadImportTemplate" class="btn btn-link btn-sm p-0 text-decoration-none">
                                <i class="bi bi-download me-1"></i> Baixar Planilha Exemplo
                            </a>
                        </div>
                        <div class="bg-light p-3 rounded-3 mb-3 border">
                            <div class="d-flex align-items-center mb-2">
                                <i class="bi bi-info-circle text-primary me-2"></i>
                                <span class="fw-bold small text-dark">Valores aceitos na coluna Grupo_DRE:</span>
                            </div>
                            <div class="d-flex flex-wrap gap-2">
                                <span class="badge bg-white text-dark border"><i class="bi bi-tag-fill me-1 text-success"></i> Receita Bruta</span>
                                <span class="badge bg-white text-dark border"><i class="bi bi-tag-fill me-1 text-danger"></i> Dedução / Imposto</span>
                                <span class="badge bg-white text-dark border"><i class="bi bi-tag-fill me-1 text-warning"></i> Custo Variável</span>
                                <span class="badge bg-white text-dark border"><i class="bi bi-tag-fill me-1 text-secondary"></i> Custo Fixo</span>
                            </div>
                        </div>

                        <div v-if="importDuplicates.length > 0" class="alert alert-danger border-0 shadow-sm mb-3">
                            <div class="d-flex">
                                <i class="bi bi-exclamation-triangle-fill fs-4 me-3"></i>
                                <div>
                                    <h6 class="fw-bold mb-1">Atenção: {{ importErrors.length }} linha(s) com dados incompletos ou DRE inválido</h6>
                                    <p class="small mb-0 text-secondary">
                                        Linhas com erro: <strong>{{importErrors.map(e => e.linha).join(', ')}}</strong>.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div v-if="!importPreviewData.length" class="upload-area p-5 border-2 border-dashed rounded text-center bg-light">
                            <input type="file" ref="fileInputImport" @change="handleFilePreview" class="d-none" accept=".xlsx,.csv">
                            <i class="bi bi-file-earmark-excel fs-1 text-muted opacity-50"></i>
                            <p class="mt-3 mb-4">Selecione a planilha de categorias para análise</p>
                            <button class="btn btn-pmg-primary" @click="$refs.fileInputImport.click()">Escolher Arquivo</button>
                        </div>

                        <div v-else>
                            <div class="alert alert-info border-0 rounded-3 small">
                                <i class="bi bi-info-circle me-2"></i>
                                Encontramos <strong>{{ importPreviewData.length }}</strong> registros para importar.
                            </div>

                            <div class="table-responsive rounded-3 border">
                                <table class="table table-sm table-hover mb-0">
                                    <thead class="bg-light">
                                        <tr>
                                            <th class="small text-muted py-2 ps-3" style="width: 50px;">#</th>
                                            <th class="small text-muted py-2" style="width: 30%;">NOME / CÓD</th>
                                            <th class="small text-muted py-2" style="width: 40%;">DESCRIÇÃO</th>
                                            <th class="small text-muted py-2" style="width: 30%;">GRUPO DRE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in importPreviewData" :key="index" :class="{ 'table-danger-light': row.isInvalid || row.isDuplicate }">
                                            <td class="ps-3 small text-muted">{{ row.excelRow }}</td>
                                            <td class="small fw-bold">
                                                <i v-if="row.isInvalid || row.isDuplicate" class="bi bi-exclamation-circle-fill text-danger me-1" :title="row.errorsList"></i>
                                                {{ row.name }}
                                            </td>
                                            <td class="small text-muted">{{ row.description }}</td>
                                            <td class="small">
                                                <span class="badge bg-secondary-subtle text-secondary">{{ row.dre }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer border-0 p-4 pt-0">
                        <button class="btn btn-pmg-light" data-bs-dismiss="modal" @click="resetImport">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="!importPreviewData.length || loading" @click="executeFinalImport">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span> Confirmar Importação
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- MODAL DE RELATÓRIO / EXPORTAÇÃO -->
        <div class="modal fade" id="modalGeneralReport" tabindex="-1" aria-hidden="true" ref="modalGeneralReport">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content border-0 shadow-lg rounded-4">
                    <div class="modal-header border-0 pt-4 px-4 pb-2">
                        <h5 class="fw-bold m-0 text-dark">Exportar Categorias</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div class="modal-body p-4">
                        <div class="row g-3">
                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted">Termo de Busca (Opcional)</label>
                                <input type="text" v-model="reportFilters.search" class="form-control form-control-pmg" placeholder="Nome ou descrição...">
                            </div>

                            <div class="col-12">
                                <label class="form-label small fw-bold text-muted">Filtrar por Grupo DRE</label>
                                <select v-model="reportFilters.dre_group" class="form-select form-control-pmg">
                                    <option value="ALL">Todos os Grupos</option>
                                    <option value="gross_revenue">Receita Bruta</option>
                                    <option value="deductions">Dedução / Imposto</option>
                                    <option value="variable_costs">Custo Variável</option>
                                    <option value="fixed_costs">Custo Fixo</option>
                                </select>
                            </div>
                        </div>

                        <div class="mt-5">
                            <button class="btn btn-pmg-primary w-100 py-3 fw-bold"
                                @click="exportFormat === 'pdf' ? downloadGeneralReport() : exportCategoriesExcel()"
                                :disabled="loadingReport">
                                <template v-if="loadingReport">
                                    <span class="spinner-border spinner-border-sm me-2"></span> PROCESSANDO...
                                </template>
                                <template v-else>
                                    <i :class="exportFormat === 'pdf' ? 'bi-file-earmark-pdf-fill' : 'bi-file-earmark-excel-fill'" class="me-2"></i>
                                    {{ exportFormat === 'pdf' ? 'GERAR RELATÓRIO PDF' : 'EXPORTAR PLANILHA XLSX' }}
                                </template>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import api from '@/services/api';
import * as XLSX from 'xlsx';

export default {
    inject: ['globalLoading'],
    data() {
        return {
            categories: [],
            alerts: [],
            isEditing: false,
            form: { id: null, name: '', description: '', dre_group: '' },
            selectedIds: [],
            filter: { name: '' },

            // Variáveis de Paginação
            totalItems: 0,
            currentPage: 1,
            lastPage: 1,
            loading: false,
            hasMore: false,

            showFilter: false,
            modalInstance: null,
            itemToDelete: null,
            isBulkDelete: false,
            importPreviewData: [],
            importFileObject: null,
            modalImportInstance: null,
            importErrors: [],
            importDuplicates: [],
            loadingReport: false,
            reportModalInstance: null,
            exportFormat: 'pdf',
            reportFilters: {
                search: '',
                dre_group: 'ALL',
            },
        }
    },
    computed: {
        isAllSelected() { return this.categories.length > 0 && this.categories.every(i => this.selectedIds.includes(i.id)); },
        isFormValid() { return this.form.name.trim() && this.form.description.trim() && this.form.dre_group.trim(); }
    },
    mounted() {
        // Inicializa o modal assim que o componente é montado
        const modalElement = document.getElementById('modalCategory');
        const reportElement = document.getElementById('modalGeneralReport');
        if (modalElement) {
            this.modalInstance = new window.bootstrap.Modal(modalElement);
        }

        if (reportElement) {
            this.reportModalInstance = new window.bootstrap.Modal(reportElement);
        }

        this.fetchCategories();
    },
    methods: {
        async fetchCategories(page = 1, append = false) {
              this.globalLoading.show('Carregando categorias...');
            this.loading = true;
            try {
                const params = {
                    page: page,
                    search: this.filter.name
                };
                const response = await api.get('/categories', { params });
                const payload = response.data;
                // Se o payload já for um array, usa ele mesmo. Se não, procura dentro de payload.data
                const items = Array.isArray(payload) ? payload : (payload.data || []);
                const paginationData = payload.meta || payload;
                const { current_page, last_page, total } = paginationData;
                if (append) {
                    this.categories = [...this.categories, ...items];
                } else {
                    this.categories = items;
                }
                this.currentPage = current_page;
                this.lastPage = last_page;
                this.totalItems = total;
                this.hasMore = this.currentPage < this.lastPage;

            } catch (error) {
                this.showAlert('Falha ao comunicar com o servidor.', 'error');
                console.error("Erro na API:", error);
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },

        loadMore() {
            if (this.hasMore && !this.loading) {
                // Busca a próxima página e marca "append" como true
                this.fetchCategories(this.currentPage + 1, true);
            }
        },

        applyFilter() {
            this.showFilter = false;
            this.selectedIds = [];
            this.isAllSelected = false;
            this.fetchCategories(1, false);
        },
        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';

            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'warning') icon = 'bi-exclamação-triangle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });

            const timeout = type === 'error' ? 6000 : 4000;
            setTimeout(() => this.removeAlert(id), timeout);
        },
        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },
        confirmDelete(target, isBulk = false) {
            this.itemToDelete = target;
            this.isBulkDelete = isBulk;
            const modal = new window.bootstrap.Modal(document.getElementById('confirmDeleteModal'));
            modal.show();
        },
        resetForm() {
            this.isEditing = false;
            this.form = { id: null, name: '', description: '', dre_group: '' };
        },
        async saveCategory() {
            this.loading = true;

            try {
                if (this.isEditing) {
                    // 1. Requisição PUT para atualizar o registro existente
                    const response = await api.put(`/categories/${this.form.id}`, this.form);
                    const updatedCategory = response.data.data || response.data;
                    const index = this.categories.findIndex(c => c.id === this.form.id);
                    if (index !== -1) {
                        this.categories[index] = updatedCategory;
                        this.showAlert("Categoria atualizada com sucesso!");
                        this.resetForm();

                    }
                } else {
                    const response = await api.post('/categories', this.form);
                    const newCategory = response.data.data || response.data;
                    this.categories.unshift(newCategory);
                    this.showAlert("Categoria salva com sucesso!");
                }
                if (this.modalInstance) {
                    this.modalInstance.hide();
                }

            } catch (e) {
                if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar.", "error");
                }

            } finally {
                // Remove o estado de loading independentemente de sucesso ou erro
                this.loading = false;
            }
        },

        async executeDeletion() {
            try {
                if (this.isBulkDelete) {
                    await api.post('/categories/bulk-delete', {
                        ids: this.selectedIds
                    });
                    this.categories = this.categories.filter(c => !this.selectedIds.includes(c.id));
                    this.totalItems -= this.selectedIds.length;
                    this.showAlert(`${this.selectedIds.length} categorias excluídas.`);
                    this.selectedIds = [];
                } else {
                    await api.delete(`/categories/${this.itemToDelete.id}`);
                    this.categories = this.categories.filter(c => c.id !== this.itemToDelete.id);
                    this.totalItems -= 1;
                    const itemName = this.itemToDelete.nome || this.itemToDelete.name;
                    this.showAlert(`Categoria "${itemName}" removida.`);
                }

            } catch (e) {
               if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao excluir registros.", "error");
                }

            } finally {
                const modalElement = document.getElementById('confirmDeleteModal');
                if (modalElement) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    }
                }
            }
        },
        toggleAll(e) {
            if (e.target.checked) this.selectedIds = this.categories.map(c => c.id);
            else this.selectedIds = [];
        },

        openModal(mode, item = null) {
            this.resetForm();
            if (mode === 'edit') {
                this.isEditing = true;
                this.form = { ...item };
            }
            // Chama o método show da instância salva
            if (this.modalInstance) {
                this.modalInstance.show();
            }
        },
        translateDre(category) {
            if (category.dre_group === 'fixed_costs') return 'Custo Fixo';
            else if (category.dre_group === 'gross_revenue') return 'Receita Bruta';
            else if (category.dre_group === 'variable_costs') return 'Custo Variável';
            else if (category.dre_group === 'deductions') return 'Dedução/Imposto';
        },
        openImportModal() {
            this.resetImport();
            if (!this.modalImportInstance) {
                this.modalImportInstance = new window.bootstrap.Modal(document.getElementById('modalImportPreview'));
            }
            this.modalImportInstance.show();
        },

        resetImport() {
            this.importPreviewData = [];
            this.importFileObject = null;
            this.importErrors = [];
            this.importDuplicates = [];
            if (this.$refs.fileInputImport) this.$refs.fileInputImport.value = '';
        },

        handleFilePreview(event) {
            const file = event.target.files[0];
            if (!file) return;

            this.importFileObject = file;
            const reader = new FileReader();

            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: 'array' });
                const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                const rawJson = XLSX.utils.sheet_to_json(worksheet);

                const nameCounts = new Map();

                rawJson.forEach(row => {
                    const name = row['Nome'] || row['nome'] || row['NOME'];
                    if (name) nameCounts.set(name, (nameCounts.get(name) || 0) + 1);
                });

                const errors = [];
                const duplicates = [];

                this.importPreviewData = rawJson.map((row, index) => {
                    const excelRow = index + 2;

                    const rowData = {
                        excelRow: excelRow,
                        name: row['Nome'] || row['nome'] || row['NOME'] || '---',
                        description: row['Descrição'] || row['Descricao'] || row['descricao'] || '---',
                        dre: row['Grupo_DRE'] || row['grupo_dre'] || row['DRE'] || '---'
                    };

                    const missingFields = [];
                    const duplicateFields = [];

                    if (rowData.name === '---') missingFields.push('Nome');
                    
                    const validDres = ['receita bruta', 'dedução / imposto', 'deducao / imposto', 'custo variável', 'custo variavel', 'custo fixo'];
                    if (!validDres.includes(rowData.dre.toLowerCase().trim())) {
                        missingFields.push('Grupo DRE Inválido');
                    }

                    if (rowData.name !== '---' && nameCounts.get(rowData.name) > 1) duplicateFields.push('Nome Repetido na Planilha');

                    if (missingFields.length > 0) errors.push({ linha: excelRow, campos: missingFields.join(', ') });
                    if (duplicateFields.length > 0) duplicates.push({ linha: excelRow, info: duplicateFields.join(' e ') });

                    rowData.isInvalid = missingFields.length > 0;
                    rowData.isDuplicate = duplicateFields.length > 0;
                    rowData.errorsList = [...missingFields, ...duplicateFields].join(', ');

                    return rowData;
                });

                this.importErrors = errors;
                this.importDuplicates = duplicates;
            };
            reader.readAsArrayBuffer(file);
        },

        async executeFinalImport() {
            if (!this.importFileObject) return;

            this.loading = true;
            const fd = new FormData();
            fd.append('file', this.importFileObject);

            try {
                await api.post('/categories/import', fd, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });

                this.showAlert("Importação inicializada em segundo plano!");
                this.modalImportInstance.hide();
                setTimeout(() => this.fetchCategories(1, false), 2000); // Atualiza após breve pausa
            } catch (e) {
                this.showAlert("Erro ao enviar arquivo de categorias para o servidor.", "error");
            } finally {
                this.loading = false;
            }
        },
       
          refreshData() {
            this.fetchCategories(1, false);
        },
         downloadImportTemplate() {
            const link = document.createElement('a');
            link.href = '/templates/modelo_importacao_categorias.xlsx';
            link.setAttribute('download', 'modelo_importacao_categorias.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        openReportModal(format = 'pdf') {
            this.exportFormat = format;
            
            // Pré-preenche os filtros do modal com os mesmos filtros ativos na tela
            this.reportFilters.search = this.filter.name;
            
            if (this.reportModalInstance) {
                this.reportModalInstance.show();
            }
        },

        async downloadGeneralReport() {
            this.loadingReport = true;
             this.globalLoading.show('Gerando PDF...');
            try {
                const params = new URLSearchParams(this.reportFilters).toString();
                const response = await api.get(`/categories/reports/general?${params}`, { responseType: 'blob' });
                
                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `relatorio_categorias_${Date.now()}.pdf`);
                document.body.appendChild(link);
                link.click();
                
                window.URL.revokeObjectURL(url);
                link.remove();
                
                this.reportModalInstance.hide();
                this.showAlert("Relatório PDF gerado com sucesso!");
            } catch (e) {
                console.error("Erro no relatório:", e);
                this.showAlert("Erro ao processar o arquivo PDF.", "error");
            } finally {
                this.loadingReport = false;
                 this.globalLoading.hide();
            }
        },

        async exportCategoriesExcel() {
            this.loadingReport = true;
             this.globalLoading.show('Gerando Planilha...');
            try {
                const params = new URLSearchParams(this.reportFilters).toString();
                const response = await api.get(`/categories/export/excel?${params}`, { responseType: 'blob' });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `categorias_${Date.now()}.xlsx`);
                document.body.appendChild(link);
                link.click();

                link.remove();
                window.URL.revokeObjectURL(url);
                
                this.reportModalInstance.hide();
                this.showAlert("Planilha gerada com sucesso!");
            } catch (e) {
                console.error(e);
                this.showAlert("Erro ao exportar planilha.", "error");
            } finally {
                this.loadingReport = false;
                this.globalLoading.hide();

            }
        },
    }
}
</script>

<style scoped>
/* ESTILOS DE ALERTA (TOASTS) */
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
}

/* LAYOUT PMG MANTIDO */
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

/* Tabela */
.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.pmg-desc-cell {
    color: #64748b;
    font-size: 0.9rem;
    max-width: 500px;
}

/* Transições */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Estilo para Erro Crítico */
.bg-error-subtle {
    background-color: #fef2f2 !important;
    /* Vermelho muito claro */
    color: #991b1b !important;
    /* Vermelho escuro para o texto */
    border-left: 5px solid #ef4444 !important;
    /* Borda viva */
}

/* Estilo para Aviso/Alerta */
.bg-warning-subtle {
    background-color: #fffbeb !important;
    /* Amarelo muito claro */
    color: #92400e !important;
    /* Marrom/Laranja para o texto */
    border-left: 5px solid #f59e0b !important;
}

/* Ajuste na animação para tremer levemente ao aparecer (opcional para erros) */
.bg-error-subtle {
    animation: shake 0.4s ease-in-out;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

.table-danger-light {
    background-color: rgba(220, 53, 69, 0.05) !important;
}

.dropdown-menu {
    z-index: 1050 !important;
}

.table-responsive {
    overflow: visible !important;
}
</style>